"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YPTA_DISCLAIMER_TEXT_LIMIT = exports.YPTA_AGE_RANGE = exports.WARNING_ICON = exports.VALIDATION_STATUS = exports.TRANSLATION = exports.TOTAL_NAME = exports.THAI_COUNTRY_LIST = exports.SINGLE_SELECT = exports.SENIOR_CITIZEN_MIN_AGE = exports.PAX_TYPE = exports.PAX_MAX_AGE = exports.MIN_DATE_TO_VALIDATE = exports.INITIAL_VALUES = exports.GENDER_OPTIONS = exports.FORM_ICONS = exports.FIELDS = exports.DATE_FORMAT_REGEX = exports.DATE_FORMAT = exports.ALPHANUMERIC_REGEX = exports.ALPHANUMERIC_NO_SPACE_REGEX = exports.ALPHABET_REGEX = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DATE_FORMAT = 'dd/MM/yyyy';
exports.DATE_FORMAT = DATE_FORMAT;
var TRANSLATION = {
  personalDetails: 'Personal details',
  givenName: 'Given name',
  familyName: 'Family name',
  nationality: 'Nationality',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  dateOfBirth: 'Date of birth',
  adult: 'Adult',
  child: 'Child',
  infant: 'Infant',
  adultAgeError: 'Adults must be {age} years and above on the date of travel',
  infantAgeError: 'Infants must be below {max} years on the date of travel',
  childAgeError: 'Children must be below {max} years on the date of travel',
  dateError: "That\u2019s an invalid date",
  requiredError: 'Field is empty',
  alphabetError: 'Please use English characters (A to Z) only. Special characters or symbols are not allowed.',
  alphanumericError: 'Please use English characters (A to Z) and Numbers only. Special characters or symbols are not allowed.',
  maxLengthError: 'Max allowed charater is {max}.',
  popoverTitle: 'Name requirements',
  popoverMessage: 'Passenger name must be entered exactly as it appears on your passport.',
  travellingWith: 'Travelling with',
  noResultLabel: 'There is no result for {0}',
  loadOptions: 'Options are loading',
  recentSearch: 'Recent Searches',
  noRightKeywordLabel: 'Please enter right type of keyword',
  clear: 'Clear',
  searchNationality: 'Search for Nationality',
  dateFormat: DATE_FORMAT,
  dateExpiredAfter: 'Expiry date should be 6 months after date of travel',
  yptaDisclaimerTitle: 'YPTA Disclaimer',
  seniorCitizenId: 'Senior Citizen ID (Optional)',
  hasInfantError: 'You need to be 18 years and above to travel with an infant. You can also link the infant to another adult.',
  firstNameMaxError: 'Max. {number} characters. Enter remaining characters as Family name/Surname instead.',
  givenNameMaxError: 'Max. {number} characters. Enter remaining characters as Family name/Surname instead.',
  familyNameMaxError: 'Max. {number} characters. Enter remaining characters as First/Given Name instead.',
  totalNameMaxError: 'Total characters of your name and family name must be within {number} characters',
  documentType: 'Travel Document Type',
  nationalId: 'National ID',
  documentNumber: 'Document number',
  passport: 'Passport',
  yptaValidationMessage: 'For travellers aged 12 to 16 years old, read about YPTA rules.'
};
exports.TRANSLATION = TRANSLATION;
var GENDER_OPTIONS = [{
  label: TRANSLATION.male,
  value: TRANSLATION.male
}, {
  label: TRANSLATION.female,
  value: TRANSLATION.female
}];
exports.GENDER_OPTIONS = GENDER_OPTIONS;
var FIELDS = {
  givenName: {
    label: TRANSLATION.givenName,
    name: 'givenName'
  },
  familyName: {
    label: TRANSLATION.familyName,
    name: 'familyName'
  },
  nationality: {
    label: TRANSLATION.nationality,
    name: 'nationality'
  },
  gender: {
    label: TRANSLATION.gender,
    name: 'gender'
  },
  dateOfBirth: {
    label: TRANSLATION.dateOfBirth,
    name: 'dateOfBirth'
  },
  travellingWith: {
    label: TRANSLATION.travellingWith,
    name: 'travellingWith'
  },
  seniorCitizenId: {
    label: TRANSLATION.seniorCitizenId,
    name: 'seniorCitizenId'
  },
  bigMemberId: {
    label: TRANSLATION.bigMemberId,
    name: 'bigMemberId'
  }
};
exports.FIELDS = FIELDS;
var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));
exports.INITIAL_VALUES = INITIAL_VALUES;
var PAX_TYPE = {
  adult: TRANSLATION.adult,
  child: TRANSLATION.child,
  infant: TRANSLATION.infant,
  ypta: 'ypta'
};
exports.PAX_TYPE = PAX_TYPE;
var PAX_MAX_AGE = {
  adult: {
    min: 12
  },
  child: {
    min: 2,
    max: 12
  },
  infant: {
    min: 0,
    max: 2
  }
};
exports.PAX_MAX_AGE = PAX_MAX_AGE;
var YPTA_AGE_RANGE = {
  min: 12,
  max: 16
};
exports.YPTA_AGE_RANGE = YPTA_AGE_RANGE;
var ALPHABET_REGEX = /^[A-Za-z ]+$/;
exports.ALPHABET_REGEX = ALPHABET_REGEX;
var ALPHANUMERIC_REGEX = /^[A-Za-z0-9 ]+$/;
exports.ALPHANUMERIC_REGEX = ALPHANUMERIC_REGEX;
var ALPHANUMERIC_NO_SPACE_REGEX = /^[A-Za-z0-9]+$/;
// eslint-disable-next-line max-len
exports.ALPHANUMERIC_NO_SPACE_REGEX = ALPHANUMERIC_NO_SPACE_REGEX;
var DATE_FORMAT_REGEX =
// eslint-disable-next-line max-len
/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(1[6-9]|[2-9]\d)\d{2}$/;
exports.DATE_FORMAT_REGEX = DATE_FORMAT_REGEX;
var YPTA_DISCLAIMER_TEXT_LIMIT = 32;
exports.YPTA_DISCLAIMER_TEXT_LIMIT = YPTA_DISCLAIMER_TEXT_LIMIT;
var SENIOR_CITIZEN_MIN_AGE = {
  min: 60
};
exports.SENIOR_CITIZEN_MIN_AGE = SENIOR_CITIZEN_MIN_AGE;
var MIN_DATE_TO_VALIDATE = '01/01/1900';
exports.MIN_DATE_TO_VALIDATE = MIN_DATE_TO_VALIDATE;
var SINGLE_SELECT = {
  color: 'neutral',
  backgroundColor: 'secondaryLight',
  borderColor: 'secondaryBlue',
  width: '109.15px'
};
exports.SINGLE_SELECT = SINGLE_SELECT;
var TOTAL_NAME = 'totalName';
exports.TOTAL_NAME = TOTAL_NAME;
var FORM_ICONS = {
  WARNING: 'ErrorIcon',
  OLD_YPTA_DISCLAIMER: 'InfoOutlinedIcon'
};
exports.FORM_ICONS = FORM_ICONS;
var WARNING_ICON = 'ErrorIcon';
exports.WARNING_ICON = WARNING_ICON;
var VALIDATION_STATUS = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
exports.VALIDATION_STATUS = VALIDATION_STATUS;
var THAI_COUNTRY_LIST = [{
  cultureCode: 'th-TH',
  countryCode3C: 'AFG',
  dialingCode: '93',
  countryCode: 'AF',
  name: 'อัฟกานิสถาน',
  defaultCurrencyCode: 'AFN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ALB',
  dialingCode: '355',
  countryCode: 'AL',
  name: 'อัลบาเนีย',
  defaultCurrencyCode: 'ALL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DZA',
  dialingCode: '213',
  countryCode: 'DZ',
  name: 'อัลจีเรีย',
  defaultCurrencyCode: 'DZD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ASM',
  dialingCode: '1684',
  countryCode: 'AS',
  name: 'อเมริกันซามัว',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AND',
  dialingCode: '376',
  countryCode: 'AD',
  name: 'แอนดอร์ร่า',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AGO',
  dialingCode: '244',
  countryCode: 'AO',
  name: 'แองโกล่า',
  defaultCurrencyCode: 'AOA'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AIA',
  dialingCode: '1264',
  countryCode: 'AI',
  name: 'แองกิวล่า',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ATA',
  dialingCode: '672',
  countryCode: 'AQ',
  name: 'แอนตาร์กติกา',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ATG',
  dialingCode: '1268',
  countryCode: 'AG',
  name: 'แอนติกัวและบาร์บูด้า',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ARG',
  dialingCode: '54',
  countryCode: 'AR',
  name: 'อาร์เจนติน่า',
  defaultCurrencyCode: 'ARS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ARM',
  dialingCode: '374',
  countryCode: 'AM',
  name: 'อาร์เมเนีย',
  defaultCurrencyCode: 'AMD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ABW',
  dialingCode: '297',
  countryCode: 'AW',
  name: 'อารูบ้า',
  defaultCurrencyCode: 'AWG'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AUS',
  dialingCode: '61',
  countryCode: 'AU',
  name: 'ออสเตรเลีย',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AUT',
  dialingCode: '43',
  countryCode: 'AT',
  name: 'ออสเตรีย',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'AZE',
  dialingCode: '994',
  countryCode: 'AZ',
  name: 'อาเซอร์ไบจาน',
  defaultCurrencyCode: 'AZN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BHS',
  dialingCode: '242',
  countryCode: 'BS',
  name: 'บาฮามาส',
  defaultCurrencyCode: 'BSD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BHR',
  dialingCode: '973',
  countryCode: 'BH',
  name: 'บาห์เรน',
  defaultCurrencyCode: 'BHD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BGD',
  dialingCode: '880',
  countryCode: 'BD',
  name: 'บังคลาเทศ',
  defaultCurrencyCode: 'BDT'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BRB',
  dialingCode: '1246',
  countryCode: 'BB',
  name: 'บาร์เบโดส',
  defaultCurrencyCode: 'BBD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BLR',
  dialingCode: '375',
  countryCode: 'BY',
  name: 'เบลารุส',
  defaultCurrencyCode: 'BYR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BEL',
  dialingCode: '32',
  countryCode: 'BE',
  name: 'เบลเยี่ยม',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BLZ',
  dialingCode: '501',
  countryCode: 'BZ',
  name: 'เบลิซ',
  defaultCurrencyCode: 'BZD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BEN',
  dialingCode: '229',
  countryCode: 'BJ',
  name: 'เบนิน',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BMU',
  dialingCode: '1441',
  countryCode: 'BM',
  name: 'เบอร์มิวด้า',
  defaultCurrencyCode: 'BMD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BTN',
  dialingCode: '975',
  countryCode: 'BT',
  name: 'ภูฏาน',
  defaultCurrencyCode: 'INR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BOL',
  dialingCode: '591',
  countryCode: 'BO',
  name: 'โบลิเวีย',
  defaultCurrencyCode: 'BOB'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BIH',
  dialingCode: '387',
  countryCode: 'BA',
  name: 'บอสเนียเฮอเซโกวีนา',
  defaultCurrencyCode: 'BAM'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BWA',
  dialingCode: '267',
  countryCode: 'BW',
  name: 'บอตสวานา',
  defaultCurrencyCode: 'BWP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BRA',
  dialingCode: '55',
  countryCode: 'BR',
  name: 'บราซิล',
  defaultCurrencyCode: 'BRL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VGB',
  dialingCode: '1284',
  countryCode: 'VG',
  name: 'หมู่เกาะเวอร์จิน อังกฤษ',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BRN',
  dialingCode: '673',
  countryCode: 'BN',
  name: 'บรูไนดารุสซาลาม',
  defaultCurrencyCode: 'BND'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BGR',
  dialingCode: '359',
  countryCode: 'BG',
  name: 'บัลกาเรีย',
  defaultCurrencyCode: 'BGN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BFA',
  dialingCode: '226',
  countryCode: 'BF',
  name: 'บูร์กินาฟาโซ',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BDI',
  dialingCode: '257',
  countryCode: 'BI',
  name: 'บุรุนดิ',
  defaultCurrencyCode: 'BIF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KHM',
  dialingCode: '855',
  countryCode: 'KH',
  name: 'แคมโบเดีย',
  defaultCurrencyCode: 'KHR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CMR',
  dialingCode: '237',
  countryCode: 'CM',
  name: 'คาเมรูน',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CAN',
  dialingCode: '1',
  countryCode: 'CA',
  name: 'แคนาดา',
  defaultCurrencyCode: 'CAD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CPV',
  dialingCode: '238',
  countryCode: 'CV',
  name: 'เคป เวอร์ดิ',
  defaultCurrencyCode: 'CVE'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CYM',
  dialingCode: '1345',
  countryCode: 'KY',
  name: 'หมู่เกาะเคย์แมน',
  defaultCurrencyCode: 'KYD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CAF',
  dialingCode: '236',
  countryCode: 'CF',
  name: 'สาธารณรัฐแอฟริกากลาง',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TCD',
  dialingCode: '235',
  countryCode: 'TD',
  name: 'จ๊าด',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CHL',
  dialingCode: '56',
  countryCode: 'CL',
  name: 'ชิลี',
  defaultCurrencyCode: 'CLP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CHN',
  dialingCode: '86',
  countryCode: 'CN',
  name: 'จีน',
  defaultCurrencyCode: 'CNY'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CXR',
  dialingCode: '61',
  countryCode: 'CX',
  name: 'เกาะคริสต์มาส',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CCK',
  dialingCode: '61',
  countryCode: 'CC',
  name: 'หมู่เกาะโคคอส (คีลลิ่ง)',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'COL',
  dialingCode: '57',
  countryCode: 'CO',
  name: 'โคลัมเบีย',
  defaultCurrencyCode: 'COP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'COM',
  dialingCode: '269',
  countryCode: 'KM',
  name: 'โคโมรอส',
  defaultCurrencyCode: 'KMF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'COD',
  dialingCode: '243',
  countryCode: 'CD',
  name: 'คองโก สาธารณรัฐประชาธิปไตย',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'COG',
  dialingCode: '242',
  countryCode: 'CG',
  name: 'สาธารณรัฐประชาชนคองโก',
  defaultCurrencyCode: 'CDF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'COK',
  dialingCode: '682',
  countryCode: 'CK',
  name: 'เกาะคุ๊ก',
  defaultCurrencyCode: 'NZD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CRI',
  dialingCode: '506',
  countryCode: 'CR',
  name: 'คอสตาริก้า',
  defaultCurrencyCode: 'CRC'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CIV',
  dialingCode: '225',
  countryCode: 'CI',
  name: 'โกตดิวัวร์',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CUB',
  dialingCode: '53',
  countryCode: 'CU',
  name: 'คิวบา',
  defaultCurrencyCode: 'CUP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CYP',
  dialingCode: '357',
  countryCode: 'CY',
  name: 'ไซปรัส',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CZE',
  dialingCode: '420',
  countryCode: 'CZ',
  name: 'สาธารณรัฐเช็ค',
  defaultCurrencyCode: 'CZK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DNK',
  dialingCode: '45',
  countryCode: 'DK',
  name: 'เดนมาร์ก',
  defaultCurrencyCode: 'DKK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DJI',
  dialingCode: '253',
  countryCode: 'DJ',
  name: 'จิบูติ',
  defaultCurrencyCode: 'DJF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DMA',
  dialingCode: '1767',
  countryCode: 'DM',
  name: 'โดมินิกา',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DOM',
  dialingCode: '1809',
  countryCode: 'DO',
  name: 'สาธารณรัฐโดมินิกัน',
  defaultCurrencyCode: 'DOP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ECU',
  dialingCode: '593',
  countryCode: 'EC',
  name: 'เอกวาดอร์',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'EGY',
  dialingCode: '20',
  countryCode: 'EG',
  name: 'อียิปต์',
  defaultCurrencyCode: 'EGP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SLV',
  dialingCode: '503',
  countryCode: 'SV',
  name: 'เอล ซัลวาดอร์',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GNQ',
  dialingCode: '240',
  countryCode: 'GQ',
  name: 'อิเควทอเรียลกินี',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ERI',
  dialingCode: '291',
  countryCode: 'ER',
  name: 'เอริเทรีย',
  defaultCurrencyCode: 'ERN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'EST',
  dialingCode: '372',
  countryCode: 'EE',
  name: 'เอสโทเนีย',
  defaultCurrencyCode: 'EEK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ETH',
  dialingCode: '251',
  countryCode: 'ET',
  name: 'เอทิโอเปีย',
  defaultCurrencyCode: 'ETB'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FRO',
  dialingCode: '298',
  countryCode: 'FO',
  name: 'หมู่เกาะฟาโรห์',
  defaultCurrencyCode: 'FKP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FLK',
  dialingCode: '500',
  countryCode: 'FK',
  name: 'หมู่เกาะฟอร์คแลนด์ (มาลวินัส)',
  defaultCurrencyCode: 'DKK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FJI',
  dialingCode: '679',
  countryCode: 'FJ',
  name: 'ฟิจิ',
  defaultCurrencyCode: 'FJD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FIN',
  dialingCode: '358',
  countryCode: 'FI',
  name: 'ฟินแลนด์',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FRA',
  dialingCode: '33',
  countryCode: 'FR',
  name: 'ฝรั่งเศส',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GUF',
  dialingCode: '594',
  countryCode: 'GF',
  name: 'เฟรนช์เกียนา',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PYF',
  dialingCode: '689',
  countryCode: 'PF',
  name: 'เฟรนช์โปลินีเซีย',
  defaultCurrencyCode: 'XPF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GAB',
  dialingCode: '241',
  countryCode: 'GA',
  name: 'กาบอง',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GMB',
  dialingCode: '220',
  countryCode: 'GM',
  name: 'แกมเบีย',
  defaultCurrencyCode: 'GMD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GEO',
  dialingCode: '995',
  countryCode: 'GE',
  name: 'จอร์เจีย',
  defaultCurrencyCode: 'GEL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'DEU',
  dialingCode: '49',
  countryCode: 'DE',
  name: 'เยอรมัน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GHA',
  dialingCode: '233',
  countryCode: 'GH',
  name: 'กาน่า',
  defaultCurrencyCode: 'GHS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GIB',
  dialingCode: '350',
  countryCode: 'GI',
  name: 'ยิบบรัลต้า',
  defaultCurrencyCode: 'GIP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GRC',
  dialingCode: '30',
  countryCode: 'GR',
  name: 'กรีซ',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GRL',
  dialingCode: '299',
  countryCode: 'GL',
  name: 'กรีนแลนด์',
  defaultCurrencyCode: 'DKK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GRD',
  dialingCode: '1473',
  countryCode: 'GD',
  name: 'เกรนาดา',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GLP',
  dialingCode: '590',
  countryCode: 'GP',
  name: 'กัวเดลูป',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GUM',
  dialingCode: '1671',
  countryCode: 'GU',
  name: 'กวม',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GTM',
  dialingCode: '502',
  countryCode: 'GT',
  name: 'กัวเตมาลา',
  defaultCurrencyCode: 'GTQ'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GIN',
  dialingCode: '224',
  countryCode: 'GN',
  name: 'กินี',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GNB',
  dialingCode: '245',
  countryCode: 'GW',
  name: 'กินี-บิสเซา',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GUY',
  dialingCode: '592',
  countryCode: 'GY',
  name: 'กายอาน่า',
  defaultCurrencyCode: 'GYD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'HTI',
  dialingCode: '509',
  countryCode: 'HT',
  name: 'ฮาอิติ',
  defaultCurrencyCode: 'HTG'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'HND',
  dialingCode: '504',
  countryCode: 'HN',
  name: 'ฮอนดูรัส',
  defaultCurrencyCode: 'HNL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'HKG',
  dialingCode: '852',
  countryCode: 'HK',
  name: 'ฮ่องกง, จีน',
  defaultCurrencyCode: 'HKD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'HRV',
  dialingCode: '385',
  countryCode: 'HR',
  name: 'โครเอเชีย',
  defaultCurrencyCode: 'HRK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'HUN',
  dialingCode: '36',
  countryCode: 'HU',
  name: 'ฮังการี',
  defaultCurrencyCode: 'HUF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ISL',
  dialingCode: '354',
  countryCode: 'IS',
  name: 'ไอซ์แลนด์',
  defaultCurrencyCode: 'ISK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'IND',
  dialingCode: '91',
  countryCode: 'IN',
  name: 'อินเดีย',
  defaultCurrencyCode: 'INR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'IDN',
  dialingCode: '62',
  countryCode: 'ID',
  name: 'อินโดนีเซีย',
  defaultCurrencyCode: 'IDR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'IRN',
  dialingCode: '98',
  countryCode: 'IR',
  name: 'อิหร่าน',
  defaultCurrencyCode: 'IRR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'IRQ',
  dialingCode: '964',
  countryCode: 'IQ',
  name: 'อิรัก',
  defaultCurrencyCode: 'IQD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'IRL',
  dialingCode: '353',
  countryCode: 'IE',
  name: 'ไอร์แลนด์',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ISR',
  dialingCode: '972',
  countryCode: 'IL',
  name: 'อิสราเอล',
  defaultCurrencyCode: 'ILS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ITA',
  dialingCode: '39',
  countryCode: 'IT',
  name: 'อิตาลี',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'JAM',
  dialingCode: '1876',
  countryCode: 'JM',
  name: 'จาไมก้า',
  defaultCurrencyCode: 'JMD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'JPN',
  dialingCode: '81',
  countryCode: 'JP',
  name: 'ญี่ปุ่น',
  defaultCurrencyCode: 'JPY'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'JOR',
  dialingCode: '962',
  countryCode: 'JO',
  name: 'จอร์แดน',
  defaultCurrencyCode: 'JOD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KAZ',
  dialingCode: '7',
  countryCode: 'KZ',
  name: 'คาซัคสถาน',
  defaultCurrencyCode: 'KZT'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KEN',
  dialingCode: '254',
  countryCode: 'KE',
  name: 'เคนย่า',
  defaultCurrencyCode: 'KES'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KIR',
  dialingCode: '686',
  countryCode: 'KI',
  name: 'คิริบาติ',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KWT',
  dialingCode: '965',
  countryCode: 'KW',
  name: 'คูเวต',
  defaultCurrencyCode: 'KWD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KGZ',
  dialingCode: '996',
  countryCode: 'KG',
  name: 'คีร์กิซสถาน',
  defaultCurrencyCode: 'KGS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LAO',
  dialingCode: '856',
  countryCode: 'LA',
  name: 'ลาว',
  defaultCurrencyCode: 'LAK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LVA',
  dialingCode: '371',
  countryCode: 'LV',
  name: 'ลัตเวีย',
  defaultCurrencyCode: 'LVL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LBN',
  dialingCode: '961',
  countryCode: 'LB',
  name: 'เลบานอน',
  defaultCurrencyCode: 'LBP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LSO',
  dialingCode: '266',
  countryCode: 'LS',
  name: 'เลโซโท',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LBR',
  dialingCode: '231',
  countryCode: 'LR',
  name: 'ไลบาเรีย',
  defaultCurrencyCode: 'LRD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LBY',
  dialingCode: '218',
  countryCode: 'LY',
  name: 'สาธารณรัฐสังคมนิยมประชาชนอาหรับลิเบีย',
  defaultCurrencyCode: 'LYD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LIE',
  dialingCode: '423',
  countryCode: 'LI',
  name: 'ลิกเตนสไตน์',
  defaultCurrencyCode: 'CHF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LTU',
  dialingCode: '370',
  countryCode: 'LT',
  name: 'ลิทูเนีย',
  defaultCurrencyCode: 'LTL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LUX',
  dialingCode: '352',
  countryCode: 'LU',
  name: 'ลักแซมเบิร์ก',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MAC',
  dialingCode: '853',
  countryCode: 'MO',
  name: 'มาเก๊า, จีน',
  defaultCurrencyCode: 'MOP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MKD',
  dialingCode: '389',
  countryCode: 'MK',
  name: 'มาซิโดเนียเหนือ',
  defaultCurrencyCode: 'MKD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MDG',
  dialingCode: '261',
  countryCode: 'MG',
  name: 'มาร์ดากัสการ์',
  defaultCurrencyCode: 'MGA'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MWI',
  dialingCode: '265',
  countryCode: 'MW',
  name: 'มาลาวี',
  defaultCurrencyCode: 'MWK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MYS',
  dialingCode: '60',
  countryCode: 'MY',
  name: 'มาเลเซีย',
  defaultCurrencyCode: 'MYR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MDV',
  dialingCode: '960',
  countryCode: 'MV',
  name: 'มัลดีฟ',
  defaultCurrencyCode: 'MVR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MLI',
  dialingCode: '223',
  countryCode: 'ML',
  name: 'มาลี',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MLT',
  dialingCode: '356',
  countryCode: 'MT',
  name: 'Malta',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MHL',
  dialingCode: '692',
  countryCode: 'MH',
  name: 'หมู่เกาะมาร์แชล',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MTQ',
  dialingCode: '596',
  countryCode: 'MQ',
  name: 'มาร์ตินีก',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MRT',
  dialingCode: '222',
  countryCode: 'MR',
  name: 'มอริเตเนีย',
  defaultCurrencyCode: 'MRO'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MUS',
  dialingCode: '230',
  countryCode: 'MU',
  name: 'มอริเชียส',
  defaultCurrencyCode: 'MUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MYT',
  dialingCode: '262',
  countryCode: 'YT',
  name: 'หมู่เกาะมายอต',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MEX',
  dialingCode: '52',
  countryCode: 'MX',
  name: 'เม็กซิโก',
  defaultCurrencyCode: 'MXN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'FSM',
  dialingCode: '691',
  countryCode: 'FM',
  name: 'ไมโครนีเซีย',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MDA',
  dialingCode: '373',
  countryCode: 'MD',
  name: 'มอลโดว่า',
  defaultCurrencyCode: 'MDL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MCO',
  dialingCode: '377',
  countryCode: 'MC',
  name: 'โมนาโค',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MNG',
  dialingCode: '976',
  countryCode: 'MN',
  name: 'มองโกเลีย',
  defaultCurrencyCode: 'MNT'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MNE',
  dialingCode: '382',
  countryCode: 'ME',
  name: 'มอนเตเนโกร',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MSR',
  dialingCode: '664',
  countryCode: 'MS',
  name: 'มอนต์เซร์รัต',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MAR',
  dialingCode: '212',
  countryCode: 'MA',
  name: 'โมร็อคโค',
  defaultCurrencyCode: 'MAD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MOZ',
  dialingCode: '258',
  countryCode: 'MZ',
  name: 'โมซัมบิก',
  defaultCurrencyCode: 'MZN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MMR',
  dialingCode: '95',
  countryCode: 'MM',
  name: 'พม่า',
  defaultCurrencyCode: 'MMK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NAM',
  dialingCode: '264',
  countryCode: 'NA',
  name: 'นามิเบีย',
  defaultCurrencyCode: 'NAD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NRU',
  dialingCode: '674',
  countryCode: 'NR',
  name: 'นาอูรู',
  defaultCurrencyCode: 'NAD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NPL',
  dialingCode: '977',
  countryCode: 'NP',
  name: 'เนปาล',
  defaultCurrencyCode: 'NPR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NLD',
  dialingCode: '31',
  countryCode: 'NL',
  name: 'เนเธอร์แลนด์',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ANT',
  dialingCode: '599',
  countryCode: 'AN',
  name: 'เนเธอร์แลนด์ แอนทิลลีส',
  defaultCurrencyCode: 'ANG'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NCL',
  dialingCode: '687',
  countryCode: 'NC',
  name: 'นิวคาลิโดเนีย',
  defaultCurrencyCode: 'XPF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NZL',
  dialingCode: '64',
  countryCode: 'NZ',
  name: 'นิวซีแลนด์',
  defaultCurrencyCode: 'NZD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NIC',
  dialingCode: '505',
  countryCode: 'NI',
  name: 'นิคารากัว',
  defaultCurrencyCode: 'NIO'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NER',
  dialingCode: '227',
  countryCode: 'NE',
  name: 'ไนเจอร์',
  defaultCurrencyCode: 'NGN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NGA',
  dialingCode: '234',
  countryCode: 'NG',
  name: 'ไนจิเรีย',
  defaultCurrencyCode: 'NGN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NIU',
  dialingCode: '683',
  countryCode: 'NU',
  name: 'นีอูเอ',
  defaultCurrencyCode: 'NZD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NFK',
  dialingCode: '672',
  countryCode: 'NF',
  name: 'เกาะนอร์ฟอล์ก',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PRK',
  dialingCode: '850',
  countryCode: 'KP',
  name: 'เกาหลีเหนือ',
  defaultCurrencyCode: 'KPW'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MNP',
  dialingCode: '1670',
  countryCode: 'MP',
  name: 'หมู่เกาะนอร์ทเทิร์น มาเรียน่า',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'NOR',
  dialingCode: '47',
  countryCode: 'NO',
  name: 'นอร์เวย์',
  defaultCurrencyCode: 'NOK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'OMN',
  dialingCode: '968',
  countryCode: 'OM',
  name: 'โอมาน',
  defaultCurrencyCode: 'OMR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PAK',
  dialingCode: '92',
  countryCode: 'PK',
  name: 'ปากีสถาน',
  defaultCurrencyCode: 'PKR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PLW',
  dialingCode: '680',
  countryCode: 'PW',
  name: 'พาเลา',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PSE',
  countryCode: 'PS',
  name: 'ปาเลสไตน์',
  dialingCode: '970',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PAN',
  dialingCode: '507',
  countryCode: 'PA',
  name: 'ปานามา',
  defaultCurrencyCode: 'PAB'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PNG',
  dialingCode: '675',
  countryCode: 'PG',
  name: 'ปาปัว นิวกีนี',
  defaultCurrencyCode: 'PGK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PRY',
  dialingCode: '595',
  countryCode: 'PY',
  name: 'ปารากวัย',
  defaultCurrencyCode: 'PYG'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PER',
  dialingCode: '51',
  countryCode: 'PE',
  name: 'เปรู',
  defaultCurrencyCode: 'PEN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PHL',
  dialingCode: '63',
  countryCode: 'PH',
  name: 'ฟิลิปปินส์',
  defaultCurrencyCode: 'PHP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'POL',
  dialingCode: '48',
  countryCode: 'PL',
  name: 'โปแลนด์',
  defaultCurrencyCode: 'PLN'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PRT',
  dialingCode: '351',
  countryCode: 'PT',
  name: 'โปรตุเกส',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'PRI',
  dialingCode: '1',
  countryCode: 'PR',
  name: 'เปอร์โต ริโก้',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'QAT',
  dialingCode: '974',
  countryCode: 'QA',
  name: 'กาตาร์',
  defaultCurrencyCode: 'QAR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'REU',
  dialingCode: '262',
  countryCode: 'RE',
  name: 'รียูเนี่ยน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ROU',
  dialingCode: '40',
  countryCode: 'RO',
  name: 'โรมาเนีย',
  defaultCurrencyCode: 'RON'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'RUS',
  dialingCode: '7',
  countryCode: 'RU',
  name: 'สหพันธรัฐรัสเซีย',
  defaultCurrencyCode: 'RUB'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'RWA',
  dialingCode: '250',
  countryCode: 'RW',
  name: 'รวันดา',
  defaultCurrencyCode: 'RWF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'BLM',
  dialingCode: '590',
  countryCode: 'BL',
  name: 'เซนต์บาร์เธเลมี่',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'MAF',
  dialingCode: '1599',
  countryCode: 'MF',
  name: 'เซนต์มาร์ติน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'WSM',
  dialingCode: '685',
  countryCode: 'WS',
  name: 'ซามัว',
  defaultCurrencyCode: 'WST'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SMR',
  dialingCode: '378',
  countryCode: 'SM',
  name: 'ซาน มาริโน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'STP',
  dialingCode: '239',
  countryCode: 'ST',
  name: 'เซาตูเมและปรินซิปี',
  defaultCurrencyCode: 'STD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SAU',
  dialingCode: '966',
  countryCode: 'SA',
  name: 'ซาอุดีอาระเบีย',
  defaultCurrencyCode: 'SAR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SEN',
  dialingCode: '221',
  countryCode: 'SN',
  name: 'ซีนีกัล',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SRB',
  dialingCode: '381',
  countryCode: 'RS',
  name: 'เซอร์เบีย',
  defaultCurrencyCode: 'RSD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SYC',
  dialingCode: '248',
  countryCode: 'SC',
  name: 'เซเชลส์',
  defaultCurrencyCode: 'SCR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SLE',
  dialingCode: '232',
  countryCode: 'SL',
  name: 'เซียร์ราลีโอน',
  defaultCurrencyCode: 'SLL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SGP',
  dialingCode: '65',
  countryCode: 'SG',
  name: 'สิงคโปร์',
  defaultCurrencyCode: 'SGD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SVK',
  dialingCode: '421',
  countryCode: 'SK',
  name: 'สโลวาเกีย (สาธารณรัฐสโลวัก)',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SVN',
  dialingCode: '386',
  countryCode: 'SI',
  name: 'สโลวาเนีย',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SLB',
  dialingCode: '677',
  countryCode: 'SB',
  name: 'หมู่เกาะโซโลมอน',
  defaultCurrencyCode: 'SBD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SOM',
  dialingCode: '252',
  countryCode: 'SO',
  name: 'โซมาเลีย',
  defaultCurrencyCode: 'SOS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ZAF',
  dialingCode: '27',
  countryCode: 'ZA',
  name: 'แอฟริกาใต้',
  defaultCurrencyCode: 'ZAR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KOR',
  dialingCode: '82',
  countryCode: 'KR',
  name: 'เกาหลีใต้',
  defaultCurrencyCode: 'KRW'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ESP',
  dialingCode: '34',
  countryCode: 'ES',
  name: 'สเปน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LKA',
  dialingCode: '94',
  countryCode: 'LK',
  name: 'ศรีลังกา',
  defaultCurrencyCode: 'LKR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SHN',
  dialingCode: '290',
  countryCode: 'SH',
  name: 'เซนต์เฮเลนา',
  defaultCurrencyCode: 'SHP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'KNA',
  dialingCode: '1869',
  countryCode: 'KN',
  name: 'เซนต์คีสต์และเนวิส',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'LCA',
  dialingCode: '1758',
  countryCode: 'LC',
  name: 'เซสต์ลูเซีย',
  defaultCurrencyCode: 'XCD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SPM',
  dialingCode: '508',
  countryCode: 'PM',
  name: 'เซนต์ปิแอร์และมิคิวลอน',
  defaultCurrencyCode: 'EUR'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VCT',
  dialingCode: '1784',
  countryCode: 'VC',
  name: 'เซสต์วินเซนต์และเกรนาดีนส์',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SDN',
  dialingCode: '249',
  countryCode: 'SD',
  name: 'ซูดาน',
  defaultCurrencyCode: 'SDG'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SUR',
  dialingCode: '597',
  countryCode: 'SR',
  name: 'ซูรีนัม',
  defaultCurrencyCode: 'XXX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SJM',
  dialingCode: '47',
  countryCode: 'SJ',
  name: 'หมู่เกาะสฟาลบาร์และจาน มาเย็น',
  defaultCurrencyCode: 'NOK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SWZ',
  dialingCode: '268',
  countryCode: 'SZ',
  name: 'เอสวาตินี',
  defaultCurrencyCode: 'SZL'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SWE',
  dialingCode: '46',
  countryCode: 'SE',
  name: 'สวีเดน',
  defaultCurrencyCode: 'SEK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'CHE',
  dialingCode: '41',
  countryCode: 'CH',
  name: 'สวิตเซอร์แลนด์',
  defaultCurrencyCode: 'CHF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'SYR',
  dialingCode: '963',
  countryCode: 'SY',
  name: 'สาธารณรัฐอาหรับซีเรีย',
  defaultCurrencyCode: 'SYP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TWN',
  dialingCode: '886',
  countryCode: 'TW',
  name: 'ไต้หวัน',
  defaultCurrencyCode: 'TWD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TJK',
  dialingCode: '992',
  countryCode: 'TJ',
  name: 'ทาจิกิสถาน',
  defaultCurrencyCode: 'TJS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TZA',
  dialingCode: '255',
  countryCode: 'TZ',
  name: 'สหสาธารณรัฐแทนเซเนีย',
  defaultCurrencyCode: 'TZS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'THA',
  dialingCode: '66',
  countryCode: 'TH',
  name: 'ไทย',
  defaultCurrencyCode: 'THB'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TMP',
  dialingCode: '670',
  countryCode: 'TP',
  name: 'สาธารณรัฐประชาธิปไตยติมอร์เลสเต้',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TLS',
  dialingCode: '670',
  countryCode: 'TL',
  name: 'Timor-Leste',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TGO',
  dialingCode: '228',
  countryCode: 'TG',
  name: 'โตโก',
  defaultCurrencyCode: 'XAF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TON',
  dialingCode: '676',
  countryCode: 'TO',
  name: 'ตองกา',
  defaultCurrencyCode: 'TOP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TTO',
  dialingCode: '1868',
  countryCode: 'TT',
  name: 'ตรินิแดดและโตบาโก',
  defaultCurrencyCode: 'TTD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TUN',
  dialingCode: '216',
  countryCode: 'TN',
  name: 'ตูนีเซีย',
  defaultCurrencyCode: 'TND'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TUR',
  dialingCode: '90',
  countryCode: 'TR',
  name: 'ตุรกี',
  defaultCurrencyCode: 'TRY'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TKM',
  dialingCode: '993',
  countryCode: 'TM',
  name: 'เติร์กเมนิสถาน',
  defaultCurrencyCode: 'TMT'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TCA',
  dialingCode: '1649',
  countryCode: 'TC',
  name: 'หมู่เกาะเติกส์และหมู่เกาะเคคอส',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'TUV',
  dialingCode: '688',
  countryCode: 'TV',
  name: 'ตูวาลู',
  defaultCurrencyCode: 'AUD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'UGA',
  dialingCode: '256',
  countryCode: 'UG',
  name: 'อูกันด้า',
  defaultCurrencyCode: 'UGX'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'UKR',
  dialingCode: '380',
  countryCode: 'UA',
  name: 'ยูเครน',
  defaultCurrencyCode: 'UAH'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ARE',
  dialingCode: '971',
  countryCode: 'AE',
  name: 'ยูไนเต็ด อาหรับ เอมิเรตส์',
  defaultCurrencyCode: 'AED'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'GBR',
  dialingCode: '44',
  countryCode: 'GB',
  name: 'สหราชอาณาจักร',
  defaultCurrencyCode: 'GBP'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'UMI',
  dialingCode: '1',
  countryCode: 'UM',
  name: 'ยูเอสไมเนอร์',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'USA',
  dialingCode: '1',
  countryCode: 'US',
  name: 'สหรัฐอเมริกา',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'URY',
  dialingCode: '598',
  countryCode: 'UY',
  name: 'อุรุกวัย',
  defaultCurrencyCode: 'UYU'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VIR',
  dialingCode: '1340',
  countryCode: 'VI',
  name: 'หมู่เกาะเวอร์จิน (สหรัฐอเมริกา)',
  defaultCurrencyCode: 'USD'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'UZB',
  dialingCode: '998',
  countryCode: 'UZ',
  name: 'อุซเบกิสถาน',
  defaultCurrencyCode: 'UZS'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VUT',
  dialingCode: '678',
  countryCode: 'VU',
  name: 'วานูอาตู',
  defaultCurrencyCode: 'VUV'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VEN',
  dialingCode: '58',
  countryCode: 'VE',
  name: 'เวเนซูเอลา',
  defaultCurrencyCode: 'VEF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'VNM',
  dialingCode: '84',
  countryCode: 'VN',
  name: 'เวียดนาม',
  defaultCurrencyCode: 'VND'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'WLF',
  dialingCode: '681',
  countryCode: 'WF',
  name: 'หมู่เกาะวาลลีสและหมู่เกาะฟูตูนา ',
  defaultCurrencyCode: 'XPF'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'YEM',
  dialingCode: '967',
  countryCode: 'YE',
  name: 'เยเมน',
  defaultCurrencyCode: 'YER'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ZMB',
  dialingCode: '260',
  countryCode: 'ZM',
  name: 'แซมเบีย',
  defaultCurrencyCode: 'ZMK'
}, {
  cultureCode: 'th-TH',
  countryCode3C: 'ZWE',
  dialingCode: '263',
  countryCode: 'ZW',
  name: 'ซิมบับเวย์',
  defaultCurrencyCode: 'ZWL'
}];
exports.THAI_COUNTRY_LIST = THAI_COUNTRY_LIST;